import React, { Component } from 'react';

import './App.css';

import Map from '../../pages/map';

class OnwrApp extends Component {
  render() {
    return (
      <>
        <Map />
      </>
    );
  }
}

export default OnwrApp;
